/* ==========================================================================
   PDP redesign — Elaré
   Runtime patch for the rating line.

   The reviews app injects "Rated <n> Excellent …" into the DOM after page
   load, so the text is not present in the served HTML and cannot be styled
   from Liquid or matched by a container selector. Walk text nodes instead,
   find the label wherever it lands, and rebuild it in the Lirae format:

       Rated **4.8 Excellent** | Over **100,000 Sold**

   The whole line goes inside one <span>: the rating row is a flex container,
   and bare text nodes there become anonymous flex items whose edge whitespace
   gets stripped — which is what collapsed the spacing on Lirae.
   ========================================================================== */
(function () {
  var RE = /Rated\s*([\d.]+)\s*Excellent(?:\s*\|?\s*(?:Over\s*)?[\d,]+\s*k?\+?\s*(?:Reviews|Sold))?/i;
  var COUNT = "100,000 Sold";
  var queued = false;

  function decorate(node) {
    var m = node.nodeValue.match(RE);
    if (!m) return;

    var before = node.nodeValue.slice(0, m.index);
    var after = node.nodeValue.slice(m.index + m[0].length);

    var line = document.createElement("span");
    line.className = "el-rating-line";

    var rating = document.createElement("strong");
    rating.textContent = m[1] + " Excellent";

    var count = document.createElement("strong");
    count.textContent = COUNT;

    // non-breaking spaces survive whitespace collapsing in flex layout
    line.appendChild(document.createTextNode("Rated "));
    line.appendChild(rating);
    line.appendChild(document.createTextNode(" | Over "));
    line.appendChild(count);

    var frag = document.createDocumentFragment();
    if (before.trim()) frag.appendChild(document.createTextNode(before));
    frag.appendChild(line);
    if (after.trim()) frag.appendChild(document.createTextNode(after));

    var host = node.parentNode;
    host.replaceChild(frag, node);
    if (host.setAttribute) host.setAttribute("data-el-rated", "1");
  }

  function scan() {
    queued = false;
    if (!document.body) return;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf("Excellent") === -1) {
          return NodeFilter.FILTER_REJECT;
        }
        var p = n.parentNode;
        if (!p || p.nodeName === "SCRIPT" || p.nodeName === "STYLE") {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var hits = [];
    while (walker.nextNode()) hits.push(walker.currentNode);
    hits.forEach(decorate);
  }

  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(scan, 0);
  }

  schedule();
  document.addEventListener("DOMContentLoaded", schedule);

  // the app renders late and may re-render; re-apply when it does
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true
  });
})();



/* ==========================================================================
   Sale band countdown
   Repeating N-minute timer shown as MM:SS. The target is cached in
   sessionStorage so it survives navigation within a visit, and rolls over to a
   fresh window once it expires.

   This file is loaded from <head>, so the band does not exist yet at parse
   time — start on DOMContentLoaded and observe in case the block renders late.
   ========================================================================== */
(function () {
  var started = false;

  function start() {
    if (started) return;
    var band = document.querySelector("[data-el-countdown]");
    if (!band) return;
    var clock = band.querySelector("[data-el-clock]");
    if (!clock) return;
    started = true;

    var minutes = parseInt(band.getAttribute("data-minutes"), 10) || 10;
    var span = minutes * 60 * 1000;
    var KEY = "el-saleband-target-" + minutes;

    function target() {
      var saved = 0;
      try { saved = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
      if (saved > Date.now()) return saved;
      var next = Date.now() + span;
      try { sessionStorage.setItem(KEY, next); } catch (e) {}
      return next;
    }

    var end = target();
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        try { sessionStorage.removeItem(KEY); } catch (e) {}
        end = target();
        left = end - Date.now();
      }
      var s = Math.floor(left / 1000);
      clock.textContent = pad(Math.floor(s / 60)) + ":" + pad(s % 60);
      setTimeout(tick, 1000);
    }

    tick();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }

  // the bundle block can render after DOMContentLoaded
  var mo = new MutationObserver(function () {
    start();
    if (started) mo.disconnect();
  });
  if (document.documentElement) {
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
